import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { XlsxService } from './../../../../shared/xlsx/xlsx.service';
import { NotificationServiceService } from './../../../../../../services/notification-service/notification-service.service';
import { ContenedoresService } from './../../../../../../services/API/contenedores/contenedores.service';
import { NewMovimientoComponent } from './../components/movimientos/new-movimiento/new-movimiento.component';
import { EditMovimientoComponent } from './../components/movimientos/edit-movimiento/edit-movimiento.component'; 
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatSort, Sort } from '@angular/material/sort';
import { AuthService } from './../../../../../../services/API/auth/auth.service';

@Component({
    selector: 'app-view-movimientos',
    templateUrl: './view-movimientos.component.html',
    styleUrls: ['./view-movimientos.component.css'],
    standalone: false
})
export class ViewMovimientosComponent implements OnInit {

  @Input() contenedorID: any = 'all';
  @Input() albaranNum: any = 'all';
  showProgressBar: boolean = true;
  displayedColumns = ['id', 'contenedorEntrega', 'fecha', 'cliente', 'albaran', 'observaciones']; 
  dataSource1: any = [];
  pages = [20, 50, 100];
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  tipo: string = 'all';

  constructor(private xlsxService: XlsxService, private dialog: MatDialog, private notificationService: NotificationServiceService, private contenedoresService: ContenedoresService, public authService: AuthService) { }

  ngOnInit(): void {
    console.log(this.albaranNum);
    this.prepareTable();
    this.getMovimientos();
  }

  getMovimientos() {
    this.showProgressBar = true;
    this.contenedoresService.getMovimientosContenedores(this.contenedorID, this.tipo, this.albaranNum).subscribe(result => {
      this.showProgressBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    });
  }

  newMovimiento() {
    const newNivelDialog = this.dialog.open(NewMovimientoComponent, {
      data: {'contenedor': this.contenedorID},
      width: '90%',
      maxWidth: '500px'
    });
    newNivelDialog.afterClosed().subscribe(result => {
      if(result === 'save'){
        this.getMovimientos();
      }
    });
  }

  editarMovimiento(id: number) {
    for (var i = 0; i < this.dataSource1.length; i++) {
      if(this.dataSource1[i]["id"] === id){
        const modifDialog = this.dialog.open(EditMovimientoComponent, {
          data: {'movimiento': id, 'tipo' : this.dataSource1[i]["tipo"], 'contenedorEntrega' : this.dataSource1[i]["contenedorEntregaID"], 'contenedorRetirada' : this.dataSource1[i]["contenedorRetiradaID"], 'fecha' : this.dataSource1[i]["fecha"], 'albaran' : this.dataSource1[i]["albaran"], 'observaciones' : this.dataSource1[i]["observaciones"], 'cliente' : this.dataSource1[i]["cliente"], 'latitud' : this.dataSource1[i]["latitud"], 'longitud' : this.dataSource1[i]["longitud"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result === 'save'){
            this.getMovimientos();
          }
        });
        break;
      }
    }
  }

  deleteMovimiento(id: number) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar movimiento', body: '¿Seguro que deseas eliminar este movimiento?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.contenedoresService.deleteMovimiento(id).subscribe(() => {
          this.notificationService.openSnackBar("Movimiento eliminado correctamente!");
          this.showProgressBar = false;
          this.getMovimientos();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Movimientos por página:';
    this.filter = '';
    this.dataSource.paginator = this.paginator;
    
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch(property) {
        case 'fecha': return this.convertirFecha(item[property]);
        case 'albaran': return parseInt(item[property]);
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    const data = this.dataSource.data;
    const excelData = data.map(item => ({
      'Tipo': item['tipo'],
      'Cont. Entregado': item['contenedorEntregaMatricula'],
      'Cont. Retirado': item['contenedorRetiradaMatricula'],
      'Fecha': item['fecha'],
      'Cliente': item['cliente'],
      'Albarán': item['albaran'],
      'Observaciones': item['observaciones'],
    }));
    this.xlsxService.saveExcelData(excelData, 'Movimientos');
  }

  convertirFecha(cadena: any) {
    const partes = cadena.split(' ');
  
    // Fecha
    const fechaPartes = partes[0].split('-');
    const dia = parseInt(fechaPartes[0], 10);
    const mes = parseInt(fechaPartes[1], 10) - 1; // Los meses en JavaScript comienzan en 0
    const anio = parseInt(fechaPartes[2], 10);
  
    /* Hora
    const horaPartes = partes[1].split(':');
    const horas = parseInt(horaPartes[0], 10);
    const minutos = parseInt(horaPartes[1], 10);*/
  
    const fecha = new Date(anio, mes, dia); // , horas, minutos
    return fecha;
  }

  canAltaMovimiento(): boolean {
    return this.authService.canAltaMovimiento();
  }

  canManageContenedores(): boolean {
    return this.authService.hasFullContenedoresAccess();
  }
  
}
